import { getMotoristas, getVeiculos } from '@spark/services';

export const filterConfig = [
  {
    id: 'ReferenciaCLiente',
    type: 'text',
    label: 'Referência Cliente',
    placeholder: 'Digite o número da referência',
  },
  {
    id: 'NumeroContainer',
    type: 'text',
    label: 'Número do container',
    placeholder: 'Digite o número do container',
  },
  {
    id: 'TipoContainer',
    type: 'select',
    label: 'Tipo do container',
    placeholder: 'Selecione o tipo do container',
    options: [
      { value: '20DC', label: '20DC' },
      { value: '40DC', label: '40DC' },
      { value: '40H', label: '40H' },
      { value: '40HC', label: '40HC' },
      { value: '40RH', label: '40RH' },
    ],
  },
  {
    id: 'StatusPedido',
    type: 'select',
    label: 'Status do pedido',
    placeholder: 'Selecione o status do pedido',
    options: [
      { value: 'OK', label: 'OK' },
      { value: 'PENDENTE', label: 'PENDENTE' },
    ],
  },
  /* {
    id: 'StatusDepot',
    type: 'select',
    label: 'Status da programação',
    placeholder: 'Selecione o status da programação',
    options: [
      { value: 'OK', label: 'OK' },
      { value: 'PENDENTE', label: 'PENDENTE' },
    ],
  }, */
  {
    id: 'IdMotoristaColeta',
    type: 'searchSelect',
    label: 'Motorista da coleta',
    placeholder: 'Digite o nome do motorista',
    minSearchLength: 2,
    maxResults: 10,
    onSearch: async (searchTerm) => {
      try {
        const response = await getMotoristas({
          Nome: searchTerm,
          quantidadePorPagina: 10,
          pagina: 1,
        });

        const lista = response?.registros || response?.data || response || [];

        return Array.isArray(lista)
          ? lista.map((mot) => ({
            value: mot.Id,
            label: mot.Nome || `Motorista ${mot.Id}`,
          }))
          : [];
      } catch (error) {
        console.error('Erro ao buscar motoristas:', error);
        return [];
      }
    },
  },
  {
    id: 'IdVeiculoColeta',
    type: 'searchSelect',
    label: 'Veículo da coleta',
    placeholder: 'Digite a placa do veículo',
    minSearchLength: 2,
    maxResults: 10,
    onSearch: async (searchTerm) => {
      try {
        const response = await getVeiculos({
          frota: searchTerm,
          quantidadePorPagina: 10,
          pagina: 1,
        });

        const lista =
          response?.registros ||
          response?.data?.registros ||
          response?.data ||
          response ||
          [];

        return Array.isArray(lista)
          ? lista.map((veic) => ({
            value: veic.Id,
            label: veic.Frota || veic.Placa || `Veículo ${veic.Id}`,
          }))
          : [];
      } catch (error) {
        console.error('Erro ao buscar veículos:', error);
        return [];
      }
    },
  },
  {
    id: 'IdMotoristaEntrega',
    type: 'searchSelect',
    label: 'Motorista da entrega',
    placeholder: 'Digite o nome do motorista',
    minSearchLength: 2,
    maxResults: 10,
    onSearch: async (searchTerm) => {
      try {
        const response = await getMotoristas({
          Nome: searchTerm,
          quantidadePorPagina: 10,
          pagina: 1,
        });

        const lista = response?.registros || response?.data || response || [];

        return Array.isArray(lista)
          ? lista.map((mot) => ({
            value: mot.Id,
            label: mot.Nome || `Motorista ${mot.Id}`,
          }))
          : [];
      } catch (error) {
        console.error('Erro ao buscar motoristas:', error);
        return [];
      }
    },
  },
  {
    id: 'IdVeiculoEntrega',
    type: 'searchSelect',
    label: 'Veículo da entrega',
    placeholder: 'Digite a placa do veículo',
    minSearchLength: 2,
    maxResults: 10,
    onSearch: async (searchTerm) => {
      try {
        const response = await getVeiculos({
          frota: searchTerm,
          quantidadePorPagina: 10,
          pagina: 1,
        });

        const lista =
          response?.registros ||
          response?.data?.registros ||
          response?.data ||
          response ||
          [];

        return Array.isArray(lista)
          ? lista.map((veic) => ({
            value: veic.Id,
            label: veic.Frota || veic.Placa || `Veículo ${veic.Id}`,
          }))
          : [];
      } catch (error) {
        console.error('Erro ao buscar veículos:', error);
        return [];
      }
    },
  },
  /* {
    id: 'StatusCTNR',
    type: 'text',
    label: 'Status do container',
    placeholder: 'Digite o status do container',
  }, */
  {
    id: 'LocalDevolucao',
    type: 'text',
    label: 'Local Devolução',
    placeholder: 'Digite o local da devolução',
  },
  {
    id: 'FreeTime',
    type: 'datePicker',
    label: 'Data do free time',
    placeholder: 'Selecione a data do free time',
    showTimeSelect: true,
  },
/*   {
    id: 'DataColeta',
    type: 'datePicker',
    label: 'Data da coleta',
    placeholder: 'Selecione a data da coleta',
    showTimeSelect: true,
  }, */
  {
    id: 'DataColetaInicio',
    type: 'datePicker',
    label: 'Data coleta (início)',
    placeholder: 'Selecione o início',
    showTimeSelect: true,
  },
  {
    id: 'DataColetaFim',
    type: 'datePicker',
    label: 'Data coleta (fim)',
    placeholder: 'Selecione o fim',
    showTimeSelect: true,
  },
/*   {
    id: 'DataEntrega',
    type: 'datePicker',
    label: 'Data da entrega',
    placeholder: 'Selecione a data da entrega',
    showTimeSelect: true,
  }, */
  {
    id: 'DataEntregaInicio',
    type: 'datePicker',
    label: 'Data entrega (início)',
    placeholder: 'Selecione o início',
    showTimeSelect: true,
  },
  {
    id: 'DataEntregaFim',
    type: 'datePicker',
    label: 'Data entrega (fim)',
    placeholder: 'Selecione o fim',
    showTimeSelect: true,
  },
/*   {
    id: 'DataDevolucao',
    type: 'datePicker',
    label: 'Data de devolução',
    placeholder: 'Selecione a data de devolução',
    showTimeSelect: true,
  }, */
  {
    id: 'DataDevolucaoInicio',
    type: 'datePicker',
    label: 'Data devolução (início)',
    placeholder: 'Selecione o início',
    showTimeSelect: true,
  },
  {
    id: 'DataDevolucaoFim',
    type: 'datePicker',
    label: 'Data devolução (fim)',
    placeholder: 'Selecione o fim',
    showTimeSelect: true,
  },
];
